import { Component, inject, ViewChild } from '@angular/core';
import { forkJoin } from 'rxjs';
import { FormFieldsSelectDataService } from '../../shared/form-fields-select-data.service';
import { routes } from '../../app.routes';
import { CodeableConceptField, FormFields, generalFieldsData, GroupField, IndividualField, SingleCodeField } from '../../shared/dynamic-forms.interface2';
import { DynamicFormsV2Component } from "../../shared/dynamic-forms-v2/dynamic-forms-v2.component";
import { FhirConversionService } from '../../shared/fhir-conversion.service';
import { FhirResourceService } from '../../shared/fhir-resource.service';
import { UtilityService } from '../../shared/utility.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-add-immunization',
  imports: [DynamicFormsV2Component, MatCardModule, MatButtonModule],
  templateUrl: './add-immunization.component.html',
  styleUrl: './add-immunization.component.scss'
})
export class AddImmunizationComponent {
  @ViewChild(DynamicFormsV2Component) dynamicForm!: DynamicFormsV2Component;
  // statusReason: "https://tx.fhir.org/r4/ValueSet/$expand?url=http://hl7.org/fhir/ValueSet/immunization-status-reason&_format=json",
  //     vaccineCode: "https://tx.fhir.org/r4/ValueSet/$expand?url=http://hl7.org/fhir/ValueSet/vaccine-code&_format=json",
  //     informationSource: "https://tx.fhir.org/r4/ValueSet/$expand?url=http://hl7.org/fhir/ValueSet/immunization-origin&_format=json",
  //     site: "https://tx.fhir.org/r4/ValueSet/$expand?url=http://hl7.org/fhir/ValueSet/immunization-site&_format=json",
  //     route: "https://tx.fhir.org/r4/ValueSet/$expand?url=http://hl7.org/fhir/ValueSet/immunization-route&_format=json",
  //     reason: "htt


  formFieldService = inject(FormFieldsSelectDataService);
  fhirConversionService = inject(FhirConversionService);
  fhirResourceService = inject(FhirResourceService);
  utilityService = inject(UtilityService);
  dialogRef = inject(MatDialogRef<AddImmunizationComponent>);

  immunizationForm?: Map<string, {
    [key: string]: any,
    formFields: FormFields[];
  }>

  ngOnInit() {
    forkJoin({
      statusReason: this.formFieldService.getFormFieldSelectData('immunization', 'statusReason'),
      vaccineCode: this.formFieldService.getFormFieldSelectData('immunization', 'vaccineCode'),
      informationSource: this.formFieldService.getFormFieldSelectData('immunization', 'informationSource'),
      site: this.formFieldService.getFormFieldSelectData('immunization', 'site'),
      route: this.formFieldService.getFormFieldSelectData('immunization', 'route'),
      reason: this.formFieldService.getFormFieldSelectData('immunization', 'reason'),
      targetDisease: this.formFieldService.getFormFieldSelectData('immunization', 'targetDisease'),
    }).subscribe((g: any) => {

      this.immunizationForm = new Map<string, {
        [key: string]: any,
        formFields: FormFields[];
      }>([[
        'status', {
          formFields: <FormFields[]>[
            <SingleCodeField>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'status',
                fieldName: "Status",
                fieldType: 'SingleCodeField',
                inputType: 'text',
                isArray: false,
                isGroup: false,
                validations: [{
                  name: 'required',
                  type: 'default'
                }],
                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
              },
              data: 'completed | entered-in-error | not-done'.split(' | '),

              // keys: ['statusReason', 'status'],
              // groupFields: {
              //   'status': <SingleCodeField>{
              //     generalProperties: <generalFieldsData>{
              //       fieldApiName: 'status',
              //       fieldName: "Status",
              //       fieldType: 'SingleCodeField',
              //       inputType: 'text',
              //       isArray: false,
              //       isGroup: false,
              //       controllingField: [{
              //         isAControlField: true,
              //         dependentFieldVisibilityTriggerValue: 'not-done',
              //         controlledFieldDependencyId: 'status.statusReason'
              //       }],

              //       auth: {
              //         read: 'all',
              //         write: 'doctor, nurse'
              //       },
              //     },
              //     data: 'completed | entered-in-error | not-done'.split(' | ')
              //   },
              //   'statusReason': <SingleCodeField>{
              //     generalProperties: <generalFieldsData>{
              //       fieldApiName: 'statusReason',
              //       fieldName: "Reason for Not Done",
              //       fieldPlaceholder: "Reason Why the immunization was not done",
              //       fieldType: 'SingleCodeField',
              //       inputType: 'text',
              //       isArray: false,
              //       isGroup: false,
              //       dependence_id: "status.statusReason",
              //       auth: {
              //         read: 'all',
              //         write: 'doctor, nurse'
              //       },
              //     },
              //     data: g.statusReason
              //   }

              // },
            },


          ]
        }
      ],




      [
        'vaccineCode', {
          formFields: <FormFields[]>[
            <CodeableConceptField>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'vaccineCode',
                fieldName: "Vaccine Code",
                fieldType: 'CodeableConceptField',
                inputType: 'text',
                isArray: false,
                isGroup: false,
                validations: [{
                  name: 'required',
                  type: 'default'
                }],
                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
              },
              data: g.vaccineCode
            },
          ]
        }


      ]







        ,


      // [
      //   'administeredProduct', {
      //     formFields: <FormFields[]>[
      //       <IndividualField>{
      //         generalProperties: <generalFieldsData>{
      //           fieldApiName: 'administeredProduct',
      //           fieldName: "Administered Product",
      //           fieldType: 'IndividualField',
      //           inputType: 'text',
      //           isArray: false,
      //           isGroup: false,

      //           auth: {
      //             read: 'all',
      //             write: 'doctor, nurse'
      //           },
      //         },

      //       },
      //     ]
      //   }

      // ]






      //   ,




      [
        'occurrenceDateTime', {
          formFields: <FormFields[]>[
            <IndividualField>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'occurrenceDateTime',
                fieldName: "Occurrence Date/Time",
                fieldType: 'IndividualField',
                inputType: 'datetime-local',
                isArray: false,
                isGroup: false,


                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
              },

            },
          ]
        }

      ]














        // [
        //   'informationSource', {
        //     formFields: <FormFields[]>[
        //       <CodeableConceptField>{
        //         generalProperties: <generalFieldsData>{
        //           fieldApiName: 'informationSource',
        //           fieldName: "Information Source",
        //           fieldType: 'CodeableConceptField',
        //           inputType: 'text',
        //           isArray: false,
        //           isGroup: false,

        //           auth: {
        //             read: 'all',
        //             write: 'doctor, nurse'
        //           },
        //         },
        //         data: g.informationSource
        //       },
        //     ]

        //   }

        // ]







        ,





      [

        'bodySite', {
          formFields: <FormFields[]>[
            <CodeableConceptField>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'bodySite',
                fieldName: "Body Site",
                fieldPlaceholder: "e.g. Left Arm",
                fieldType: 'CodeableConceptField',
                allowedOthers: true,
                allowTextForCodeableConcept: true,
                inputType: 'text',
                isArray: false,
                isGroup: false,

                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
              },
              data: g.site
            },
          ]
        }
      ]











        ,

      [

        'route', {
          formFields: <FormFields[]>[
            <CodeableConceptField>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'route',
                fieldName: "Route",
                fieldType: 'CodeableConceptField',
                fieldPlaceholder: "e.g. Intramuscular",
                inputType: 'text',
                isArray: false,
                isGroup: false,

                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
              },
              data: g.route
            },
          ]
        }
      ]















        ,

      [
        'doseQuantity', {
          formFields: <FormFields[]>[
            <GroupField>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'doseQuantity',
                fieldName: "Dose Quantity",
                fieldType: 'IndividualField',
                isArray: false,
                isGroup: true,

                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
              },
              keys: ['value', 'unit'],
              groupFields: {
                'value': <IndividualField>{
                  generalProperties: <generalFieldsData>{
                    fieldApiName: 'value',
                    fieldName: "Value",
                    fieldType: 'IndividualField',
                    inputType: 'number',
                    validations: [{
                      name: 'required',
                      type: 'default'
                    }],
                    auth: {
                      read: 'all',
                      write: 'doctor, nurse'
                    },
                  }
                },
                'unit': <IndividualField>{
                  generalProperties: <generalFieldsData>{
                    fieldApiName: 'unit',
                    fieldName: "Unit",
                    fieldType: 'IndividualField',
                    inputType: 'text',
                    fieldPlaceholder: 'e.g. mL, mg',
                    validations: [{
                      name: 'required',
                      type: 'default'
                    }],
                    auth: {
                      read: 'all',
                      write: 'doctor, nurse'
                    },
                  }
                }
              }
            },
          ]
        }
      ]






        ,


      // [
      //   'targetDisease', {
      //     formFields: <FormFields[]>[
      //       <CodeableConceptField>{
      //         generalProperties: <generalFieldsData>{
      //           fieldApiName: 'targetDisease',
      //           fieldName: "Target Disease",
      //           fieldType: 'CodeableConceptField',
      //           inputType: 'text',
      //           isArray: false,
      //           isGroup: false,

      //           auth: {
      //             read: 'all',
      //             write: 'doctor, nurse'
      //           },
      //         },
      //         data: g.targetDisease
      //       },
      //     ]
      //   }

      // ]










      //   ,


      [
        'reasonCode', {
          formFields: <FormFields[]>[
            <CodeableConceptField>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'reasonCode',
                fieldName: "Reason",
                fieldType: 'CodeableConceptField',
                allowedOthers: true,
                allowTextForCodeableConcept: true,
                inputType: 'text',
                isArray: false,
                isGroup: false,

                auth: {
                  read: 'all',
                  write: 'doctor, nurse'
                },
              },
              data: g.reason
            },
          ]
        }


      ]















        ,













      ])


      this.formFieldsToUse = this.utilityService.convertFormFields(this.immunizationForm);

    });
  }
  formFieldsToUse?: any[];

  confirm() {
    if (this.dynamicForm) {
      const formData = this.dynamicForm.aForm.value;
      const rawImmunization = this.fhirConversionService.immunizationFormToFhir(formData);
// $#$      // /* alert(JSON.stringify(rawImmunization) */)
      // const cleanedImmunization = this.utilityService.cleanResource(rawImmunization);

      this.fhirResourceService.postResource('Immunization', rawImmunization).subscribe((resp) => {
        if (resp.saved) {
          this.dialogRef.close(resp.resource);
        }
      });
    }
  }

}
